exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2X2yCI1apLbzgmii0Q6oCO{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._1yE-UJD1Vuoih6tE1JwSeO{color:\"[theme:neutralPrimary, default:#323130]\"}@media screen and (-ms-high-contrast:active){._1yE-UJD1Vuoih6tE1JwSeO{-ms-high-contrast-adjust:none;color:\"[theme:neutralSecondary, default:#605e5c]\"}}._1bH5SwDCDD5umcFQjNgXyX{color:\"[theme:neutralSecondary, default:#605e5c]\"}", ""]);
// Exports
exports.locals = {
	"textOverFlow": "_2X2yCI1apLbzgmii0Q6oCO",
	"firstLineCommonStyle": "_1yE-UJD1Vuoih6tE1JwSeO",
	"secondLineCommonStyle": "_1bH5SwDCDD5umcFQjNgXyX"
};